<template>

    <div class="row d-flex justify-content-center">

        <loading-div v-if='!isReady'></loading-div>

        <div v-if='isReady' class="col-10">
            <div class="fieldset">
                <h3 class="fieldset-title">Известия</h3> 

                <div class="clr-legend d-flex justify-content-end">
                    <span class="clr clr-active d-flex align-items-center"> Нови </span>
                    <span class="clr d-flex align-items-center"> Видяни </span>
                </div>

                <div v-for='(n,i) in notifs' :class="['notification', { active : n.seen == 0 }]">
                    <h4 class="notif-name">
                        {{ n.title }}
                    </h4>
                    <p>{{ n.content }}</p>
                    <div class="d-sm-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center mt-2">
                            <a v-if='n.url' :href="n.url" class="btn btn-primary btn-sm">
                                Виж тук
                            </a>
                            
                            <span @click='removeNotif(n,i)' class="ml-3 pointer"> Изтрий </span>
                        </div>

                        <div class="date mt-2">
                            {{ dateOnly( n.created_at )}} , {{ timeOnly( n.created_at ) }}
                        </div>
                    </div>                    
                </div>                

                <div class='col-12'>
                    <paginator v-if='isReady && total > perPage'
                               :total='total'
                               v-on:page-change='changePage'
                               :perPage='perPage'>
                    </paginator>
                </div>

            </div>
        </div>
        
    </div>

</template>

<script>
    export default {

        mounted() {

            this.getData();

        },

        created() {
            
        },

        data() {
            return {

                isReady : false,
                model   : false,
                
                perPage : 10,   //Results per page
                page    : 1,    //Current page
                pages   : 0,    //Total number of pages
                total   : 0,    //Total results

                notifs  : [],
            }
        },

        methods : {
            
            getData() {

                var me = this,
                    data = { pp : this.perPage, p : this.page };

                //First pull, get count
                if( !this.isReady ) {
                    data.init = 1;
                }

                me.ajax.call('usr:gnt', data, (r) => {

                    if( r.status == 'success' ) {
                        me.notifs = r.data.notifs;

                        if( !me.isReady ) {

                            me.total = r.data.c;
                            me.isReady = true;
                        
                        }

                    }

                })

            },

            removeNotif( n,i ) {
                var me = this;

                me.ajax.call('usr:rmn', { n : n.id }, (r) => {
                    
                    if( r.status == 'success' ) {
                        me.notifs.splice(i,1);
                        $.notify("Нотификацията беше премахната","success");
                    }

                })
            },

            changePage( p ) {
                this.page = p;

                this.getData();

            }

        },

        components : { 
            
        }

    }
</script>
